import { useEffect, useState } from "react";
import { Bed, Lightbulb, Music, Tv, Wind, Shield, Wifi, Coffee, Droplet, Sparkles, Heart, Wine, Star } from "lucide-react";
import { motion, Reveal, StaggerContainer, staggerItem, easeLuxury } from "../components/motion";
import api from "../lib/api";

const ICON_MAP = {
  bed: Bed, lightbulb: Lightbulb, music: Music, tv: Tv, wind: Wind,
  shield: Shield, wifi: Wifi, coffee: Coffee, droplet: Droplet,
  sparkles: Sparkles, heart: Heart, wine: Wine, star: Star,
};

export default function AmenitiesPage() {
  const [amenities, setAmenities] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/amenities")
      .then((r) => setAmenities(r.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="pt-32 pb-24 grain min-h-screen" data-testid="amenities-page">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <Reveal>
          <div className="text-center max-w-2xl mx-auto mb-20">
            <div className="eyebrow">Curated For Two</div>
            <h1 className="font-display text-5xl sm:text-6xl mt-6">Amenities</h1>
            <div className="divider-gold mx-auto" />
            <p className="text-luxury-body">Every detail engineered for intimacy &amp; indulgence.</p>
          </div>
        </Reveal>

        {loading ? (
          <div className="flex justify-center py-20">
            <div className="w-6 h-6 border border-gold/40 border-t-gold rounded-full animate-spin" />
          </div>
        ) : (
          <StaggerContainer className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6" stagger={0.08}>
            {amenities.map((a, i) => {
              const Icon = ICON_MAP[a.icon] || Star;
              return (
                <motion.div
                  key={a.id}
                  variants={staggerItem}
                  whileHover={{ y: -10, transition: { duration: 0.4, ease: easeLuxury } }}
                  className="glass p-8 tilt gold-glow-hover cursor-default"
                  data-testid={`amenity-card-${i}`}
                >
                  <motion.div
                    className="w-12 h-12 border border-gold/40 flex items-center justify-center mb-6"
                    whileHover={{ rotate: 360, borderColor: "rgba(212,175,55,1)" }}
                    transition={{ duration: 0.7, ease: easeLuxury }}
                  >
                    <Icon className="text-gold" size={20} />
                  </motion.div>
                  <h3 className="font-display text-2xl text-white mb-3">{a.title}</h3>
                  <p className="text-luxury-body text-sm">{a.description}</p>
                </motion.div>
              );
            })}
          </StaggerContainer>
        )}
      </div>
    </div>
  );
}
